import { render } from "./Edit.pug?vue&type=template&id=1ca3f9fc&ts=true&lang=pug&external"
import script from "./Edit.ts?vue&type=script&lang=ts&external"
export * from "./Edit.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/staffs/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ca3f9fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ca3f9fc', __exports__)) {
    api.reload('1ca3f9fc', __exports__)
  }
  
  module.hot.accept("./Edit.pug?vue&type=template&id=1ca3f9fc&ts=true&lang=pug&external", () => {
    api.rerender('1ca3f9fc', render)
  })

}


export default __exports__